// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__6M5PS","subheader":"style_subheader__d0wrE"};